import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { IRootState } from './types/IRootState';
import auth from './ApiAuthState';

import attributeFilterGetters from './getters/FilterGetters/AttributeFilterGetters';
import manufacturerFilterGetters from './getters/FilterGetters/ManufacturerFilterGetters';
import companyFilterGetters from './getters/FilterGetters/CompanyFilterGetters';
import itemTypeFilterGetters from './getters/FilterGetters/ItemTypeFilterGetters';
import categoryFilterGetters from './getters/FilterGetters/CategoryFilterGetters';
import itemGetters from './getters/ItemGetters';
import languageGetters from './getters/languageGetters';
import onlyClientItemsGetters from './getters/onlyClientItemsGetters';
import filterGetters from './getters/FilterGetters/FiltersGetters';
import rootStateGetters from './getters/RootStateGetters';

import attributeFilterMutations from './mutations/FilterMutations/AttributeFiltersMutations';
import manufacturerFilterMutations from './mutations/FilterMutations/ManufacturerFilterMutations';
import companyFilterMutations from './mutations/FilterMutations/CompanyFilterMutations';
import itemTypeFilterMutations from './mutations/FilterMutations/ItemTypeFilterMutations';
import categoryFilterMutations from './mutations/FilterMutations/CategoryFilterMutations';
import itemMutations from './mutations/ItemMutations';
import apiAuthMutations from './mutations/ApiAuthMutations';
import languageMutations from './mutations/languageMutations';
import onlyClientItemsMutations from './mutations/onlyClientItemsMutations';
import filterMutations from './mutations/FilterMutations/FilterMutations';
import rootStateMutations from './mutations/RootStateMutations';

import itemActions from './actions/ItemActions';
import apiAuthActions from './actions/ApiAuthActions';
import VueI18n from 'vue-i18n';

Vue.use(Vuex);

const store: StoreOptions<IRootState> = {
  state: {
    hasFilters: false,
    searchString: '',
    defaultMaxItems: 30,
    currentMaxItems: 30,
    itemsCounter: 0,
    hasEmptySearchResponse: false,
      selectedSearchFieldOption: { name: 'nome_descricao_codigo_pn', id: 'Descricao'},
      searchTypes: [
          { name: 'pesquisa_por_descricao_codigo_pn', id: 'Descricao' },
          { name: 'pesquisa_por_empresa', id: 'Empresas' },
          { name: 'pesquisa_por_ncm', id: 'NCM' },
          { name: 'pesquisa_por_info_tecnicas', id: 'info_tecnicas' },
          { name: 'pesquisa_por_lista_codigo', id: 'lista_codigo' },
          { name: 'pesquisa_por_lista_pn', id: 'lista_part_number' },
    ],
    auth,
    attributeFilters: [],
    manufacturerFilters: {
      filters: [],
      showAllFilters: true,
      showFilterGroup: true,
    },
    companyFilters: {
      filters: [],
      showAllFilters: true,
      showFilterGroup: true,
    },
    itemTypeFilters: {
      filters: [],
      showAllFilters: true,
      showFilterGroup: true,
    },
    categoryFilters: {
      groupings: [],
      showAllFilters: true,
      showFilterGroup: true,
    },
    items: [],
    activeLanguages: [],
    onlyClientItems: false,
    globalLanguage: '',
    isLoading: false,
    error: {
      status: 0,
      message: '',
    },
    isDisplayList: true,
    previewUrl: '',
  },
  getters: {
    ...attributeFilterGetters,
    ...manufacturerFilterGetters,
    ...itemGetters,
    ...languageGetters,
    ...onlyClientItemsGetters,
    ...filterGetters,
    ...rootStateGetters,
    ...companyFilterGetters,
    ...itemTypeFilterGetters,
    ...categoryFilterGetters,
  },
  mutations: {
    ...attributeFilterMutations,
    ...itemMutations,
    ...apiAuthMutations,
    ...languageMutations,
    ...onlyClientItemsMutations,
    ...manufacturerFilterMutations,
    ...filterMutations,
    ...rootStateMutations,
    ...companyFilterMutations,
    ...itemTypeFilterMutations,
    ...categoryFilterMutations,
  },
  actions: {
    ...itemActions,
    ...apiAuthActions,
  },
};

export default new Vuex.Store<IRootState>(store);
